import * as c from '../../constants/filemanager';
import {
  ENG_SEND_WORK_AREA_SUCCESS,
  ENG_UPDATE_SKETCHER_SUCCESS,
} from '../../constants/engineering';
import { GDL_INIT_SUCCESS } from '../../constants/app';
import {
  GAME_LEVEL_UP_SUCCESS,
  GAME_CHANGE_LEVEL_SUCCESS,
} from '../../constants/game';

export const defaultState = {
  initialized: false,
  visible: false,
  menu: c.FM_MENU_MAIN,
  concepts: [],
  revisions: [],
  selectedConcept: null,
  selectedRevision: null,
  workingConcept: '',
  isDirty: false,
  showCompare: false,
  loading: {
    designList: false,
    command: false,
  },
  enableAutoSave: true,
};

const filemanager = (state = defaultState, action) => {
  switch (action.type) {
    case GDL_INIT_SUCCESS:
      return { ...state, workingConcept: action.result.filename };
    case GAME_LEVEL_UP_SUCCESS:
    case GAME_CHANGE_LEVEL_SUCCESS:
      return {
        ...state,
        selectedConcept: defaultState.selectedConcept,
        selectedRevision: defaultState.selectedRevision,
        workingConcept: defaultState.workingConcept,
        isDirty: defaultState.isDirty,
      };
    case c.FM_SHOW:
      return { ...state, visible: true };
    case c.FM_HIDE:
      return { ...state, visible: false, menu: c.FM_MENU_MAIN };
    case c.FM_SELECT_MENU:
      if (
        [
          c.FM_MENU_MAIN,
          c.FM_MENU_NEW,
          c.FM_MENU_OPEN,
          c.FM_MENU_SAVE,
          c.FM_MENU_FORK,
          c.FM_MENU_SHARE,
        ].indexOf(action.menu) < 0
      ) {
        return state;
      }
      return { ...state, menu: action.menu };
    case c.FM_NEW_CONCEPT:
    case c.FM_FORK_CONCEPT:
    case c.FM_OPEN_REVISION:
    case c.FM_SAVE_REVISION:
      return {
        ...state,
        loading: { ...state.loading, command: true },
      };
    case c.FM_NEW_CONCEPT_SUCCESS:
      return {
        ...state,
        isDirty: false,
        workingConcept: '',
        visible: false,
        loading: { ...state.loading, command: false },
        menu: c.FM_MENU_MAIN,
      };
    case c.FM_SAVE_REVISION_SUCCESS:
      return {
        ...state,
        isDirty: false,
        workingConcept: action.name,
        loading: { ...state.loading, command: false },
        visible: action.autoSave ? state.visible : false,
        menu: c.FM_MENU_MAIN,
      };
    case c.FM_FORK_CONCEPT_SUCCESS:
    case c.FM_OPEN_REVISION_SUCCESS:
      return {
        ...state,
        isDirty: false,
        workingConcept: action.name,
        loading: { ...state.loading, command: false },
        visible: false,
        menu: c.FM_MENU_MAIN,
      };
    case c.FM_NEW_CONCEPT_FAILURE:
    case c.FM_OPEN_REVISION_FAILURE:
    case c.FM_SAVE_REVISION_FAILURE:
    case c.FM_FORK_CONCEPT_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, command: false },
      };
    case c.FM_LOAD_CONCEPTS:
      return {
        ...state,
        loading: { ...state.loading, designList: true },
      };
    case c.FM_LOAD_CONCEPTS_SUCCESS:
      const { concepts, revisions } = action.result;
      return {
        ...state,
        initialized: true,
        loading: { ...state.loading, designList: false },
        concepts,
        revisions,
      };
    case c.FM_LOAD_CONCEPTS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, designList: false },
      };
    case c.FM_SAVE_NOTES_SUCCESS:
      const { id, notes, lastModified } = action.result;
      const index = state.revisions.findIndex((r) => r.id === id);
      if (index >= 0) {
        const revisions = [
          ...state.revisions.slice(0, index),
          { ...state.revisions[index], notes, lastModified },
          ...state.revisions.slice(index + 1),
        ];
        return { ...state, revisions };
      } else {
        return state;
      }
    case c.FM_ENABLE_AUTOSAVE:
      return { ...state, enableAutoSave: true };
    case c.FM_DISABLE_AUTOSAVE:
      return { ...state, enableAutoSave: false };
    case ENG_UPDATE_SKETCHER_SUCCESS:
    case ENG_SEND_WORK_AREA_SUCCESS:
      return { ...state, isDirty: true };
    default:
      return state;
  }
};

export default filemanager;
